import { render, staticRenderFns } from "./expert-info.vue?vue&type=template&id=79542f80&"
import script from "./expert-info.vue?vue&type=script&lang=js&"
export * from "./expert-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports